var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyVessel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 240h240V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 74.547H81.345V61.36c0-1.035.84-1.875 1.875-1.875h22.504c1.035 0 1.874.84 1.874 1.875v13.188zM103.805 59.485H85.14v-4.411c0-.85.69-1.54 1.54-1.54h15.586c.85 0 1.54.69 1.54 1.54v4.41zM132.46 37.252c-27.965-9.561-47.573-1.901-51.222-.268a.557.557 0 0 1-.768-.39l-1.018-4.47a.556.556 0 0 1 .297-.626c3.144-1.508 23.413-10.195 54.536.464a.573.573 0 0 1 .356.723l-1.472 4.228a.558.558 0 0 1-.709.339z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.16 74.556a7.848 7.848 0 0 1 7.848 7.848V205.42a7.848 7.848 0 0 1-7.848 7.848H78.84a7.848 7.848 0 0 1-7.848-7.848V82.404a7.848 7.848 0 0 1 7.848-7.848h82.32z",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.378 40.69v-.07h-5.81v.802c-.804.37-.185.835 0 1.174v1.555c-.804.37-.185.834 0 1.174v1.554c-.804.37-.185.835 0 1.174v5.482h5.81v-8.88c.835-.433 0-1.236 0-1.236v-1.493c.835-.433 0-1.236 0-1.236z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.332 32.697v6.328c0 .88-.714 1.595-1.595 1.595h-8.529a1.595 1.595 0 0 1-1.595-1.595v-4.508M161.16 74.556a7.848 7.848 0 0 1 7.848 7.848V205.42a7.848 7.848 0 0 1-7.848 7.848H78.84a7.848 7.848 0 0 1-7.848-7.848V82.404a7.848 7.848 0 0 1 7.848-7.848h82.32z",
    stroke: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVessel);
export default __webpack_public_path__ + "static/media/empty-vessel.c61a6a18b33b9818004869bc79a31db4.svg";
export { ForwardRef as ReactComponent };